import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'

import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import container from '../../wires/Bootstrapper'

import { SearcherBaseModel } from '../../models/SearcherBaseModel'
import { IUtenteService } from '../../services/UtenteService'
import { ListUtenti } from './ListUtenti'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { ai } from '../../TelemetryService'

export class PageUtentiBackofficeComp extends React.Component<RouteComponentProps, any> {

    service: IUtenteService

    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.UTENTE_BACKOFFICE_SERVICE)
    }

    onUtenteClick = id => {
        this.props.history.push(`UtenteBackoffice/Modifica/${id}`)
    }

    onUtenteNewClick = () => {
        this.props.history.push(`UtenteBackoffice/Modifica`)
    }

    search = async (model: SearcherBaseModel) => {
        return this.service.Search(model)
    }

    render() {
        return (
            <ListUtenti title="Utenti di backoffice" onSearch={this.search} onUtenteClick={this.onUtenteClick} onUtenteNewClick={this.onUtenteNewClick} />
        )
    }
}

export const PageUtentiBackoffice = withRouter(withAITracking(ai.reactPlugin, PageUtentiBackofficeComp,"PageUtentiBackoffice"))